module.exports = __webpack_public_path__ + "static/media/list.2b9a51c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/list.svg
// module id = 1476
// module chunks = 0